import { motion } from "framer-motion";
import { MEDIA } from "../data/content";
import Reveal from "./Reveal";

const Partnerships = () => {
  return (
    <section
      id="partnerships"
      data-testid="partnerships-section"
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-24 bg-beige-light border-y border-royal/10"
    >
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-12 bg-gold" />
              <span className="font-accent text-sm uppercase tracking-[0.28em] text-gold">
                Exterior Solutions
              </span>
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-royal text-4xl md:text-5xl lg:text-6xl leading-[1.08]">
              Enhancing exteriors through{" "}
              <span className="italic text-gold-gradient">trusted partnerships.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-titanium leading-relaxed max-w-lg text-lg">
              From structural steel framing to advanced building materials, our
              integrated network of specialist companies delivers precision
              engineering and premium finishes across every development we touch.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 flex flex-wrap gap-3">
              {["Steel Framing", "Building Materials", "Cryogenics", "Bio Energy"].map(
                (tag) => (
                  <span
                    key={tag}
                    className="font-accent text-sm uppercase tracking-[0.18em] border border-royal/20 text-royal/80 px-4 py-2 hover:border-gold hover:text-gold transition-colors"
                  >
                    {tag}
                  </span>
                )
              )}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 grid grid-cols-2 gap-5">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="overflow-hidden border border-royal/10 group mt-10"
          >
            <img
              src={MEDIA.exterior1}
              alt="Exterior solution detail"
              className="w-full h-[300px] md:h-[380px] object-cover scale-105 group-hover:scale-110 transition-transform duration-[900ms]"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="overflow-hidden border border-royal/10 group"
          >
            <img
              src={MEDIA.exterior2}
              alt="Architectural facade"
              className="w-full h-[300px] md:h-[380px] object-cover scale-105 group-hover:scale-110 transition-transform duration-[900ms]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Partnerships;
